// extracted by mini-css-extract-plugin
export default {"newCommentContainer":"PostNewComment_newCommentContainer__YGR3r","commentInput":"PostNewComment_commentInput__O3FK-"};